import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Button, { ButtonProps } from 'vibo-ui/Button';

import { useNotifications } from 'components/context/NotificationsContext';

import { useModal } from 'vibo-ui/Modal';

import { Modals } from 'types/enums';
import { IconmoonFont } from 'vibo-ui/Icon';

const AddNotificationButton: FC<ButtonProps> = ({ ...rest }) => {
  const { t } = useTranslation();

  const { canAddNotif, create } = useNotifications();

  const { openModal } = useModal();

  const openCustomNotificationModal = useCallback(() => {
    openModal({
      key: Modals.customNotification,
      props: {
        create,
      },
    });
  }, []);

  return canAddNotif ? (
    <Button
      onClick={openCustomNotificationModal}
      prefixIcon={IconmoonFont['plus-16']}
      shape="round"
      size="lg"
      {...rest}
    >
      {t('addNotification')}
    </Button>
  ) : null;
};

export default AddNotificationButton;
